import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import {filter, get, map, orderBy, startCase} from 'lodash';
import {Dropdown} from 'primereact/dropdown';
import MappingAmsToNetworkDisplayPathButton from '../app/mapping-ams-to-network-displaypath-button';
import MoviesAndProgramsSearchForm from './movies-and-programs-search-form';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesSearchPanelAction from '../app/services-search-panel-action';
import Thumbnail from '../core/thumbnail';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './movies-and-programs-for-network-display-path.scss';
import rsqlConfig from '../../../config/rsql-config';
import filterConfig from '../../../config/filter-config';

const servicesDataKey = 'moviesAndProgramsForNetworkDisplayPath';

class MoviesAndProgramsForNetworkDisplayPath extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: filterConfig.moviesAndProgramsMapping,
            selectedFilter: null,
        };
    }

  componentWillReceiveProps(nextProps) {
        const {colorFilterSet} = this.props;

        if (
            nextProps?.colorFilterSet &&
            nextProps?.colorFilterSet[servicesDataKey] &&
            nextProps?.colorFilterSet[servicesDataKey] !== colorFilterSet[servicesDataKey]
        ) {
            this.setState({
                selectedFilter: nextProps?.colorFilterSet[servicesDataKey],
            });
        } else if (nextProps.colorFilterSet && nextProps?.colorFilterSet[servicesDataKey] === null) {
            this.setState({
                selectedFilter: null,
            });
        }
    }

    onFilterChange(e) {
        const {code} = e.value;
        const {servicesDataSearch, setFieldValue, setColorFilter} = this.props;
        this.setState({selectedFilter: code !== 'linkedNot' ? e.value : null});
        setColorFilter(servicesDataKey, code !== 'linkedNot' ? e.value : null);
        setFieldValue(servicesDataKey, 'linkedOnlyFilter', '');
        servicesDataSearch(servicesDataKey);
        if (code !== 'linkedNot') {
            setFieldValue(servicesDataKey, 'linkedOnlyFilter', `=rsql=${rsqlConfig[code]}`);
            servicesDataSearch(servicesDataKey);
        }
    }

    getColumnConfig() {
        const {mapButtonOnClick} = this.props;
        return [
            {
                dataKey: 'title',
                formatter: 'moviesAndProgramsTitle',
                sortKey: 'title.sortable',
                title: 'Title',
                width: '17%',
            },
            {
                dataKey: 'episodeSeason',
                title: 'S',
                tooltip: 'Season Number',
                width: '3%',
            },
            {
                dataKey: 'episodeNumber',
                title: 'E',
                tooltip: 'Episode Number',
                width: '3%',
            },
            {
                dataKey: 'echostarContentType',
                title: 'Type',
                tooltip: 'Echostar Content Type',
                width: '6%',
            },
            {
                dataKey: 'echostarId',
                title: 'E* ID',
                tooltip: 'Echostar ID',
                width: '7%',
            },
            {
                dataKey: 'description',
                title: 'Description',
                width: '42%',
            },
            {
                dataKey: 'releaseYear',
                title: 'Released',
                tooltip: 'Release Year',
                type: 'string',
                width: '6%',
            },
            {
                dataKey: 'originalAirDate',
                title: 'Original Air',
                tooltip: 'Original Air Date',
                type: 'date',
                width: '8%',
            },
            {
                dataKey: '',
                title: '',
                type: 'component',
                component: MappingAmsToNetworkDisplayPathButton,
                componentProps: (searchData) => ({...searchData, mapButtonOnClick}),
                width: '8%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxResults: 10000,
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: [
                'description',
                'sportDatetime',
                'sportSeasonType',
                'episodeSeason',
                'programType',
                'genres',
                'runtime',
                'rating',
                'titleLanguages',
                'descriptionLanguage',
            ],
            headerRenderer: this.renderThumbnails,
            isMapping: true,
        };
    }

    getTableWithSortProps() {
        return {
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            detailLinkPrefix: '',
            ...this.props,
        };
    }

    renderThumbnails = (searchData) => {
        const images = orderBy(filter(get(searchData, '0.images', []), 'url'), 'category');

        return images.length ? (
            <div className="movies-and-programs-for-network-displaypath--thumbnail-group">
                {map(images, ({amsGalleryId, category, height, url, width}) => (
                    <Thumbnail
                        className="movies-and-programs-for-network-displaypath--thumbnail"
                        height={height}
                        key={amsGalleryId}
                        label={startCase(category)}
                        src={url}
                        width={width}
                    />
                ))}
            </div>
        ) : null;
    };

    renderForm = () => <MoviesAndProgramsSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey} />;

    renderFilters = () => {
        const {filters, selectedFilter} = this.state;
        return (
            <div className="movies-and-programs-for-network-display-path--filters">
                <Dropdown
                    optionLabel="name"
                    options={filters}
                    placeholder="Select a Filter"
                    value={selectedFilter}
                    onChange={(e) => this.onFilterChange(e)}
                />
            </div>
        );
    };

    render() {
        return (
            <div className="movies-and-programs-for-network-display-path--div">
                <ServicesSearchPanelAction contentRenderer={this.renderForm} showPanel={true} />
                <div style={{display: 'flex'}}>
                    <SearchPagination {...this.getPaginationProps()} />
                    {this.renderFilters()}
                </div>
                <SearchTableWithSort {...this.getTableWithSortProps()} />
            </div>
        );
    }
}

MoviesAndProgramsForNetworkDisplayPath.propTypes = {
    colorFilterSet: PropTypes.object,
    detailLinkPrefix: PropTypes.string,
    mapButtonOnClick: PropTypes.func,
    panelId: PropTypes.string,
    query: PropTypes.object,
    renderForm: PropTypes.func,
    searchData: PropTypes.array,
    servicesDataSearch: PropTypes.func.isRequired,
    servicesSearchData: PropTypes.object,
    setColorFilter: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    tableWithSortProps: PropTypes.object,
    totalPages: PropTypes.number,
};

export default withSearch(MoviesAndProgramsForNetworkDisplayPath, servicesDataKey);
